import React from "react"
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./config/i18n";
import "./App.css"

ReactDOM.render(
  <React.StrictMode>
  {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
  <BrowserRouter>
    <App />
  </BrowserRouter>
  </React.StrictMode>
  , document.getElementById("root")
)
